import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import entryGuideService from '../../services/entryGuideService';
import EntryGuideForm from '../../components/EntryGuides/EntryGuideForm';
import Toast from '../../components/Common/Toast';
import FormLoadingSpinner from '../../components/Common/FormLoadingSpinner';

const EditEntryGuide = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [entryGuide, setEntryGuide] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  useEffect(() => {
    const loadEntryGuide = async () => {
      try {
        setLoading(true);
        const response = await entryGuideService.getEntryGuide(id);
        if (response.success && response.data) {
          setEntryGuide(response.data);
        } else {
          setToast({ isOpen: true, message: 'No se pudo cargar la guía de entrada', type: 'error' });
          setTimeout(() => navigate('/warehouses'), 2000);
        }
      } catch (error) {
        console.error('Error al cargar guía de entrada:', error);
        setToast({ isOpen: true, message: 'Error al cargar la guía de entrada', type: 'error' });
        setTimeout(() => navigate('/warehouses'), 2000);
      } finally {
        setLoading(false);
      }
    };
    loadEntryGuide();
  }, [id, navigate]);

  const handleSuccess = () => {
    setToast({
      isOpen: true,
      message: 'Guía de entrada actualizada exitosamente',
      type: 'success'
    });
    setTimeout(() => {
      if (entryGuide?.warehouse_id) {
        navigate(`/warehouses/${entryGuide.warehouse_id}/documents`);
      } else {
        navigate('/warehouses');
      }
    }, 1500);
  };

  if (!loading && !entryGuide) {
    return null;
  }

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        {/* Header según tipo de guía */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">
            {loading && 'Editar guía'}
            {!loading && entryGuide?.guide_type === 'salida' && 'Editar Guía de Salida'}
            {!loading && entryGuide?.guide_type === 'inicial' && 'Editar Guía de Saldo Inicial'}
            {!loading && entryGuide?.guide_type === 'traspaso' && 'Editar Guía de Traspaso'}
            {!loading && entryGuide?.guide_type === 'recepcion' && 'Editar Guía de Recepción'}
            {!loading && (!entryGuide?.guide_type || entryGuide?.guide_type === 'entrada') && 'Editar Guía de Entrada'}
          </h1>
          <p className="text-gray-600 mt-1">Modifique la información de la guía</p>
        </div>

        {loading ? (
          <FormLoadingSpinner
            message="Cargando guía…"
            hint="Obteniendo ítems, referencias y datos del almacén"
          />
        ) : (
          <EntryGuideForm
          isOpen={true}
          onClose={() => {
            if (entryGuide.warehouse_id) {
              navigate(`/warehouses/${entryGuide.warehouse_id}/documents`);
            } else {
              navigate('/warehouses');
            }
          }}
          entryGuide={entryGuide}
          warehouseId={entryGuide.warehouse_id}
          onSuccess={handleSuccess}
          isPageMode={true}
          isExit={entryGuide.guide_type === 'salida'}
          isInitial={entryGuide.guide_type === 'inicial'}
          isTransfer={entryGuide.guide_type === 'traspaso'}
          isReception={entryGuide.guide_type === 'recepcion'}
        />
        )}

        {/* Toast de notificaciones */}
        <Toast
          isOpen={toast.isOpen}
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ ...toast, isOpen: false })}
        />
      </div>
    </div>
  );
};

export default EditEntryGuide;

